import React from 'react';
import Link from 'next/link';

import { ICourse } from 'modules/courses';
import { globalConst } from 'modules/global';

import CourseAvatar from './course-avatar';
import CourseImage from './course-image';
import CoursePrice from './course-price';

interface IProps {
  course?: ICourse;
}

const CourseCard: React.FC<IProps> = ({ course }) => (
  <Link href={`${globalConst.pageNames.COURSES}/${course?.slug}`} className="block rounded-xl bg-white">
    <CourseImage
      id={course?.id}
      name={course?.name}
      rating={course?.rating}
      saved={course?.is_saved}
      image={course?.image?.large}
    />
    <div className="flex items-end justify-between p-2">
      <CourseAvatar
        courseName={course?.name}
        slug={course?.teacher?.slug}
        createdAt={course?.created_at}
        userName={course?.teacher?.full_name}
        userImage={course?.teacher?.image?.small}
      />
      <CoursePrice price={course?.price} discountPercent={course?.discount_percent} isFree={course?.type === 'free'} />
    </div>
  </Link>
);

export default CourseCard;
